import {graphql} from 'react-relay'

export const query = graphql`
  query PipelineBreadcrumbsQuery($pipelineLocator: String!, $fetchPipeline: Boolean!) {
    pipeline(pipelineLocator: $pipelineLocator) @include(if: $fetchPipeline) {
      ...PipelineBreadcrumbsFragment
    }
  }
`
